import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import moment from "moment";
import { ThreeCircles } from "react-loader-spinner";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";

import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

const TOP_KPIS_FIRST_PAGE = {
  vehiclecount: 0,
  total_km: 0,
  median_range: 0,
  mean_whr_km: 0,
  idel_time_per: 0,
  avg_dis_duration: 0,
  regen_percent: 0,
  median_BCS_max: 0,
  median_BMS_max: 0,
  mcu_temp: 0,
  motor_temp: 0,
  dcdc_temp: 0,
};

function Topkpis({ gloablfilter }) {
  const [topdata, setTopData] = useState(TOP_KPIS_FIRST_PAGE);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  function median(numbers) {
    const sorted = Array.from(numbers).sort((a, b) => a - b);
    const middle = Math.floor(sorted.length / 2);

    if (sorted.length % 2 === 0) {
      if (((sorted[middle - 1] + sorted[middle]) / 2).toFixed(2) !== "NaN")
        return ((sorted[middle - 1] + sorted[middle]) / 2).toFixed(2);
      else return 0;
    }
    if (sorted[middle].toFixed(2) !== "NaN") return sorted[middle].toFixed(2);
    else return 0;
  }

  const appyData = (data) => {
    const res_result = data;

    let total_vehicle_count = 0;
    let distanceInKM = 0;
    let responce = {};
    let adddist = 0;
    let rangeMedian = [];
    let mean_whr_km = [];
    let idel_time_per = [];
    let avg_dis_duration = [];
    if (res_result.length != 0) {
      let temp_result_new = res_result;
      temp_result_new.map((temp_result) => {
        total_vehicle_count += temp_result.total_vehicle_count.value;
        distanceInKM += temp_result.distanceInKM.value;
        rangeMedian.push(temp_result.rangeMedian.values["50.0"]);
        mean_whr_km.push(temp_result.whKMmedian.values["50.0"]);
        idel_time_per.push(temp_result.idleTimePer.values["50.0"]);
        avg_dis_duration.push(temp_result.medianDuration.values["50.0"]);
      });
      responce = {
        vehiclecount: total_vehicle_count,
        total_km: distanceInKM.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        median_range: median(rangeMedian),
        mean_whr_km: median(mean_whr_km),
        idel_time_per: (median(idel_time_per) / 3600).toFixed(2),
        avg_dis_duration: (median(avg_dis_duration) / 3600).toFixed(2),
      };
      setTopData((prestate) => responce);
    } else {
      setTopData((prestate) => TOP_KPIS_FIRST_PAGE);
    }
    distanceInKM.push(adddist);
  };

  const appyDataErc = (data) => {
    const res_result = data;
    let total_vehicle_count = 0;
    let distanceInKM = 0;
    let responce = {};
    let adddist = 0;
    let rangeMedian = [];
    let mean_whr_km = [];
    let idel_time_per = [];
    let avg_dis_duration = [];
    let median_regen = [];
    let median_BCS = [];
    let median_BMS = [];
    let median_MCU = [];
    let median_motor = [];
    let median_DCDC = [];
    if (res_result.length != 0) {
      let temp_result_new = res_result;
      let countcheck = 0;
      temp_result_new.map((temp_result) => {
        if (
          temp_result.discharge_cycle.doc_count > gloablfilter.DISCHARGE &&
          (temp_result.distanceInKM.value === 0
            ? temp_result.distanceInKM.value >= gloablfilter.DELTA
            : temp_result.distanceInKM.value > gloablfilter.DELTA)
        ) {
          countcheck += 1;
          total_vehicle_count += temp_result.total_vehicle_count.value;
          distanceInKM += temp_result.distanceInKM.value;
          rangeMedian.push(temp_result.rangeMedian.values["50.0"]);
          mean_whr_km.push(temp_result.whKMmedian.values["50.0"]);
          idel_time_per.push(
            temp_result.idleTimePer.values["50.0"] === null
              ? 0
              : temp_result.idleTimePer.values["50.0"]
          );
          avg_dis_duration.push(temp_result.medianDuration.values["50.0"]);
          median_regen.push(temp_result["Median_Regen_Per"].values["50.0"]);
          median_BCS.push(
            temp_result["BCS_Active_Time_Percent"].values["50.0"]
          );
          median_BMS.push(temp_result["Median_BMS_Max_Temp"].values["50.0"]);
          median_MCU.push(temp_result["Median_MCU_Temp"].values["50.0"]);
          median_motor.push(temp_result["Median_motor_temp"].values["50.0"]);
          median_DCDC.push(temp_result["Median_DCDC_Temp"].values["50.0"]);
        }
      });

      responce = {
        vehiclecount: total_vehicle_count,
        total_km: distanceInKM.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        median_range: median(rangeMedian),
        mean_whr_km: median(mean_whr_km),
        idel_time_per: median(idel_time_per),
        avg_dis_duration: (median(avg_dis_duration) / 60).toFixed(1),
        regen_percent: median(median_regen),
        median_BMS_max: median(median_BMS),
        median_BCS_max: median(median_BCS),
        mcu_temp: median(median_MCU),
        motor_temp: median(median_motor),
        dcdc_temp: median(median_DCDC),
      };
      setTopData((prestate) => responce);
    } else {
      setTopData((prestate) => TOP_KPIS_FIRST_PAGE);
    }
    distanceInKM.push(adddist);
  };

  useEffect(() => {
    if (loggedInUser.flagForHideShow !== "ERC") {
      fetchData(
        {
          url: API_URL_MAIN + "drivefilter/topkpisfirstpage",
          body: { filterdata: gloablfilter },
        },
        appyData
      );
    } else {
      fetchData(
        {
          url: API_URL_MAIN + "drivefilter/topkpisfirstpage_erc",
          body: { filterdata: gloablfilter },
        },
        appyDataErc
      );
    }
  }, [gloablfilter]);
  console.log(topdata.vehiclecount);

  let loader = (
    <div style={{ margin: "auto" }}>
      <ThreeCircles
        height="50"
        width="40"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="three-circles-rotating"
        outerCircleColor="#3498db"
        innerCircleColor="#dec52d"
        middleCircleColor="#db213a"
      />
    </div>
  );

  const loggedInUser = useSelector(selectLoggedInUser);
  // console.log("KPI Section");
  // console.log("KPI Section");
  console.log(topdata.vehiclecount);

  return (
    <>
      <section className="kpi my-3">
        <div className="row row-cols-2">
          <div className="col ">
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src={"/assets/img/EV-Logo-1.png"} />{" "}
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.vehiclecount}</p>
                <p className="m-0">
                  <small className="text-muted drive_span">Vehicle Count</small>
                </p>
              </div>
            </div>
          </div>
          <div className="col evtpks-pl0">
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src="/assets/img/charging1.png" />{" "}
              </div>
              <div className="ps-2">
                <p className="h5 m-0 kpi_value">{topdata.total_km} km</p>
                <p className="m-0">
                  <small className="text-muted drive_span">
                    Total km travelled
                  </small>
                </p>
              </div>
            </div>
          </div>
          <div className="col evtpks-pl0">
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src="/assets/img/charging-station1.png" />{" "}
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.median_range} km</p>
                <p className="m-0">
                  <small className="text-muted drive_span">Median Range</small>
                </p>
              </div>
            </div>
          </div>
          <div className="col evtpks-pl0">
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src="/assets/img/electric1.png" />{" "}
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.mean_whr_km}</p>
                <p className="m-0">
                  <small className="text-muted drive_span">Median Wh/km</small>
                </p>
              </div>
            </div>
          </div>
          <div className="col evtpks-pl0">
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                  : "widget p-2 py-3 d-flex align-items-center"
              }
              style={{ marginLeft: 0 }}
            >
              <div className="widgetIcon">
                <img src="/assets/img/electric-car1.png" />{" "}
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.idel_time_per}%</p>
                <p className="m-0">
                  <small className="text-muted drive_span">
                    Idle time percentage
                  </small>
                </p>
              </div>
            </div>
          </div>
          {loggedInUser.flagForHideShow === "ERC" && (
            <div className="col evtpks-pl0">
              <div
                className={
                  loggedInUser.flagForHideShow === "ERC"
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginRight: 0 }}
              >
                <div className="widgetIcon">
                  <img src="/assets/img/battery-charge1.png" />{" "}
                </div>
                <div className="ps-0">
                  <p className="h5 m-0 kpi_value">
                    {topdata.avg_dis_duration} hrs
                  </p>
                  <p className="m-0">
                    <small className="text-muted drive_span">
                      Median discharge duration
                    </small>
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {loggedInUser.flagForHideShow === "ERC" && (
          <div className="row row-cols-2 mt-2">
            <div className="col ">
              <div
                className={
                  loggedInUser.flagForHideShow === "ERC"
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-1">
                  <img src={"/assets/img/Rgen.png"} />{" "}
                </div>
                <div className="pl-0">
                  <p className="h5 m-0 kpi_value">{topdata.regen_percent} %</p>
                  <p className="m-0">
                    <small className="text-muted drive_span">
                      Median Regen Percent
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  loggedInUser.flagForHideShow === "ERC"
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-0">
                  <img src="/assets/img/bcs_active.png" alt="" />{" "}
                </div>
                <div className="ps-1">
                  <p className="h6 m-0 kpi_value">{topdata.median_BCS_max} %</p>
                  <p className="m-0 kpi_text">
                    <small className="text-muted drive_span ">
                      Med. BCS Active Percent
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  loggedInUser.flagForHideShow === "ERC"
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-1">
                  <img src="/assets/img/thermometer.png" alt="" />{" "}
                </div>
                <div className="ps-0">
                  <p className="h5 m-0 kpi_value">
                    {parseFloat(topdata.median_BMS_max).toFixed(1)} °C
                  </p>
                  <p className="m-0 kpi_text">
                    <small className="text-muted drive_span">
                      Median BMS Max Temp
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  loggedInUser.flagForHideShow === "ERC"
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-1">
                  <img src="/assets/img/mcu.png" />{" "}
                </div>
                <div className="pl-1">
                  <p className="h5 m-0 kpi_value">
                    {parseFloat(topdata.mcu_temp).toFixed(1)} °C
                  </p>
                  <p className="m-0">
                    <small className="text-muted drive_span">
                      Median MCU Temp
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  loggedInUser.flagForHideShow === "ERC"
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-1">
                  <img src="/assets/img/motor.png" />{" "}
                </div>
                <div className="pl-1">
                  <p className="h5 m-0 kpi_value">
                    {parseFloat(topdata.motor_temp).toFixed(1)} °C
                  </p>
                  <p className="m-0">
                    <small className="text-muted drive_span">
                      Median Motor Temp
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col evtpks-pl0">
              <div
                className={
                  loggedInUser.flagForHideShow === "ERC"
                    ? "widget widgetstyle p-2 py-2 d-flex align-items-center"
                    : "widget p-2 py-3 d-flex align-items-center"
                }
                style={{ marginLeft: 0 }}
              >
                <div className="widgetIcon pl-1">
                  <img src="/assets/img/dcdc.png" />{" "}
                </div>
                <div className="pl-1">
                  <p className="h5 m-0 kpi_value">
                    {parseFloat(topdata.dcdc_temp).toFixed(1)} °C
                  </p>
                  <p className="m-0">
                    <small className="text-muted drive_span">
                      Median DCDC Temp
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
}

export default Topkpis;
